import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

const Icon = props => {
  const {
    className,
    name,
    size = "small",
    style
  } = props,
        rest = __rest(props, ["className", "name", "size", "style"]);

  const fontSize = {
    small: "1rem",
    medium: "1.5rem",
    large: "2rem"
  }[size];
  const verticalAlign = {
    small: "-0.175em",
    medium: "-0.25em",
    large: "-0.325em"
  }[size];
  return jsx("i", Object.assign({
    className: classNames("ld", `ld-${name}`, className),
    // eslint-disable-next-line react/forbid-dom-props
    style: Object.assign({
      fontSize,
      verticalAlign
    }, style)
  }, rest), void 0);
};

const withIcon = WrappedComponent => {
  return props => {
    const {
      a11yLabel,
      size = "small",
      style
    } = props,
          rest = __rest(props, ["a11yLabel", "size", "style"]);

    const fontSize = {
      small: "1rem",
      medium: "1.5rem",
      large: "2rem"
    }[size];
    const verticalAlign = {
      small: "-0.175em",
      medium: "-0.25em",
      large: "-0.325em"
    }[size];
    const a11yProps = a11yLabel ? {
      "aria-label": a11yLabel,
      role: "img"
    } : {
      "aria-hidden": true,
      role: "presentation"
    };
    return jsx(WrappedComponent, Object.assign({}, rest, a11yProps, {
      // eslint-disable-next-line react/forbid-component-props
      style: Object.assign({
        fontSize,
        verticalAlign
      }, style)
    }), void 0);
  };
};

const SvgArrowDown = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7.647 13.854l-3.5-3.5a.5.5 0 1 1 .707-.708L7.5 12.293V2.458C7.5 2.205 7.724 2 8 2s.5.205.5.458v9.835l2.647-2.647a.5.5 0 0 1 .707.707l-3.5 3.5a.5.5 0 0 1-.707 0z"
    }, void 0)
  }), void 0);
};

var ArrowDown = withIcon(SvgArrowDown);

const SvgArrowLeft = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.354 4.146a.5.5 0 0 0-.638-.057l-.07.057-3.528 3.532-.051.072-.03.06-.02.062-.012.056L2 8l.003.053.014.075.02.063.04.076.04.055 3.53 3.532.069.057a.5.5 0 0 0 .568 0l.07-.057.057-.07a.5.5 0 0 0 0-.568l-.057-.07L3.708 8.5H13.5a.5.5 0 0 0 .09-.992L13.5 7.5H3.706l2.648-2.646.057-.07a.5.5 0 0 0-.057-.638z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ArrowLeft = withIcon(SvgArrowLeft);

const SvgArrowRight = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.646 4.146a.5.5 0 0 1 .708 0l3.5 3.5.011.013a.503.503 0 0 1 .033.039l.013.018A.497.497 0 0 1 14 8v.02a.503.503 0 0 1-.005.052L14 8a.502.502 0 0 1-.146.354l.044-.052a.503.503 0 0 1-.033.04l-.011.012-3.5 3.5-.07.057a.5.5 0 0 1-.638-.057l-.057-.07a.5.5 0 0 1 .057-.638L12.292 8.5H2.5a.5.5 0 0 1-.09-.992L2.5 7.5h9.794L9.646 4.854l-.057-.07a.5.5 0 0 1 .057-.638z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ArrowRight = withIcon(SvgArrowRight);

const SvgArrowUp = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.354 2.146l3.5 3.5a.5.5 0 1 1-.707.708L8.5 3.707v9.835c0 .253-.224.458-.5.458s-.5-.205-.5-.458V3.707L4.854 6.354a.5.5 0 0 1-.708-.707l3.5-3.5a.5.5 0 0 1 .708 0z"
    }, void 0)
  }), void 0);
};

var ArrowUp = withIcon(SvgArrowUp);

const SvgArticle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 1a.5.5 0 0 1 .492.41L15 1.5v11a2.5 2.5 0 0 1-2.336 2.495L12.5 15H4a3 3 0 0 1-3-3 .5.5 0 0 1 .41-.492l.09-.008h1v-10a.5.5 0 0 1 .41-.492L3 1h11.5zM10 12.5H2.064l.02.078a2.001 2.001 0 0 0 1.767 1.417L4 14l6.5.001a2.487 2.487 0 0 1-.491-1.292L10 12.5zM14 2H3.5v9.5h7a.5.5 0 0 1 .469.326l.023.084L11 12v.5a1.5 1.5 0 0 0 2.993.144L14 12.5V2zm-2.5 6a.5.5 0 0 1 .09.992L11.5 9H5.018a.5.5 0 0 1-.09-.992L5.018 8H11.5zm-2-2a.5.5 0 0 1 .09.992L9.5 7H5.018a.5.5 0 0 1-.09-.992L5.018 6H9.5zm-2-2a.5.5 0 0 1 .09.992L7.5 5H5.018a.5.5 0 0 1-.09-.992L5.018 4H7.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Article = withIcon(SvgArticle);

const SvgAssociate = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a3.5 3.5 0 0 1 2.425 6.023A3.998 3.998 0 0 1 14 11v4H2v-4a4 4 0 0 1 3.575-3.978A3.5 3.5 0 0 1 8 1zm2 7H6a3 3 0 0 0-2.995 2.824L3 11v3h10v-3a3 3 0 0 0-2.824-2.995L10 8zm-4.946 4.185c.13-.224.357-.33.509-.243l1.462 1.025c.084.069.091.224.012.361-.08.137-.217.209-.32.175L5.1 12.747c-.156-.087-.179-.338-.046-.562zm5.382-.243c.152-.088.38.019.513.243.129.224.106.475-.046.562l-1.622.756c-.102.034-.239-.038-.319-.175-.08-.137-.072-.292.012-.36zm-2.438-1.459c.262 0 .467.145.467.32l-.156 1.78c-.019.107-.152.19-.311.19-.156 0-.289-.083-.304-.19l-.16-1.78c0-.175.205-.32.464-.32zM8 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Associate = withIcon(SvgAssociate);

const SvgBan = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm4.581 3.125l-8.456 8.456a6 6 0 0 0 8.456-8.456zM8 2a6 6 0 0 0-4.581 9.875l8.456-8.456A5.976 5.976 0 0 0 8 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Ban = withIcon(SvgBan);

const SvgBarcode = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M5 2a.5.5 0 0 1 .09.992L5 3H2v10h3a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L5 14H1.5a.5.5 0 0 1-.492-.41L1 13.5v-11a.5.5 0 0 1 .41-.492L1.5 2H5zm9.5 0l.09.008a.5.5 0 0 1 .402.402L15 2.5v11l-.008.09a.5.5 0 0 1-.402.402L14.5 14H11l-.09-.008a.5.5 0 0 1-.402-.402l-.008-.09.008-.09a.5.5 0 0 1 .402-.402L11 13h3V3h-3l-.09-.008a.5.5 0 0 1 0-.984L11 2h3.5zM4 6v4H3V6h1zm5 0v4H7V6h2zm2 0v4h-1V6h1zm2 0v4h-1V6h1zM6 6v4H5V6h1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Barcode = withIcon(SvgBarcode);

const SvgBell = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7 13.25V14h2v-.75h1V14a1 1 0 0 1-.883.993L9 15H7a1 1 0 0 1-.993-.883L6 14v-.75h1zM8 1a1.75 1.75 0 0 1 1.744 1.606l.006.144.001.353A4.501 4.501 0 0 1 12.5 7.25v3.043l.854.853a.5.5 0 0 1 .14.275l.006.079v1.25a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5V11.5a.5.5 0 0 1 .146-.354l.854-.854V7.25a4.501 4.501 0 0 1 2.75-4.147V2.75C6.25 1.784 7.034 1 8 1zm0 2.75a3.5 3.5 0 0 0-3.5 3.5v3.25a.5.5 0 0 1-.146.354l-.854.852v.543h9v-.542l-.854-.853a.5.5 0 0 1-.14-.275L11.5 10.5V7.25A3.5 3.5 0 0 0 8 3.75zM8 2a.75.75 0 0 0-.743.648l-.007.102v.062c.176-.03.356-.049.538-.057L8 2.75c.256 0 .507.021.75.062V2.75A.75.75 0 0 0 8 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Bell = withIcon(SvgBell);

const SvgBox = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12.704 1.5a.5.5 0 0 1 .438.26l1.796 3.268a.5.5 0 0 1 .062.24V14a.5.5 0 0 1-.5.5h-13A.5.5 0 0 1 1 14V5.268a.5.5 0 0 1 .062-.24l1.796-3.269a.5.5 0 0 1 .438-.259h9.408zM14 5.5H2v8h12v-8zm-8 6V13H3v-1.5h3zm1.5-9H3.59l-1.098 2H7.5v-2zm4.909 0H8.5v2h5.007l-1.098-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Box = withIcon(SvgBox);

const SvgCalendar = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.5 2a.5.5 0 0 1 .492.41L11 2.5V3h3.25a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-9.5A.75.75 0 0 1 1.75 3H5v-.5a.5.5 0 0 1 .992-.09L6 2.5V3h4v-.5a.5.5 0 0 1 .5-.5zM14 7H2v6h12V7zm-1.5 2v2h-2V9h2zM5 4H2v2h12V4h-3v.5a.5.5 0 0 1-.992.09L10 4.5V4H6v.5a.5.5 0 0 1-.992.09L5 4.5V4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Calendar = withIcon(SvgCalendar);

const SvgCamera = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 3a.75.75 0 0 1 .75.75v8.5a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-8.5A.75.75 0 0 1 1.75 3h12.5zM14 4H2v8h12V4zm-3.5 1.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM5 5a.5.5 0 0 1 .09.992L5 6H3.5a.5.5 0 0 1-.09-.992L3.5 5H5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Camera = withIcon(SvgCamera);

const SvgCar = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11.18 1a1 1 0 0 1 .98.804L13 6h.5a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1H13v1.5a.5.5 0 0 1-.5.5H11a.5.5 0 0 1-.5-.5V13h-5v1.5a.5.5 0 0 1-.5.5H3.5a.5.5 0 0 1-.5-.5V13h-.5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1H3l.84-4.196A1 1 0 0 1 4.82 1h6.36zM2.5 7v5h11V7h-11zm2 1a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3zm-7 1a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm7 0a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1zm-.32-7H4.82l-.801 4h7.961l-.8-4z"
    }, void 0)
  }), void 0);
};

var Car = withIcon(SvgCar);

const SvgCaretDown = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 10l3.5-4h-7z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CaretDown = withIcon(SvgCaretDown);

const SvgCaretUp = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 6l3.5 4h-7z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CaretUp = withIcon(SvgCaretUp);

const SvgCart = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11.659 11.25a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm-6 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zM3.5 1.75a.5.5 0 0 1 .492.41L4 2.25v1.5h10.5a.5.5 0 0 1 .492.41l.008.09v6a.5.5 0 0 1-.41.492l-.09.008h-11a.5.5 0 0 1-.492-.41L3 10.25v-7.5H1.5a.5.5 0 0 1-.492-.41L1 2.25a.5.5 0 0 1 .41-.492l.09-.008h2zm10.5 3H4v5h10v-5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Cart = withIcon(SvgCart);

const SvgCartFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11.652 11.55a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm-5.997 0a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5zm-2.249-9.6a.6.6 0 0 1 .592.503l.008.097-.001 1.4H14.4a.6.6 0 0 1 .592.503L15 4.55v6a.6.6 0 0 1-.502.592l-.098.008H3.406a.6.6 0 0 1-.592-.503l-.008-.097v-7.4H1.6a.6.6 0 0 1-.592-.503L1 2.55a.6.6 0 0 1 .502-.592L1.6 1.95h1.806z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CartFill = withIcon(SvgCartFill);

const SvgChatBubble = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.27 1.5c-3.705 0-6.73 2.69-6.73 6.038l.007.294a5.9 5.9 0 0 0 .812 2.733l.141.224-1.45 2.993-.03.079a.5.5 0 0 0 .686.595l3.376-1.529-.216-.098c1.012.488 2.195.747 3.404.747 3.705 0 6.73-2.69 6.73-6.038C15 4.189 11.975 1.5 8.27 1.5zm0 1C11.447 2.5 14 4.77 14 7.538c0 2.768-2.553 5.038-5.73 5.038-1.061 0-2.096-.227-2.97-.648l-.082-.031a.5.5 0 0 0-.341.026l-2.325 1.051.976-2.012a.5.5 0 0 0-.048-.516 4.869 4.869 0 0 1-.94-2.908C2.54 4.769 5.093 2.5 8.27 2.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ChatBubble = withIcon(SvgChatBubble);

const SvgCheck = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12.646 3.896a.5.5 0 0 1 .75.66l-.042.048-7.5 7.5a.5.5 0 0 1-.655.045l-.047-.04-2.5-2.429a.5.5 0 0 1 .649-.758l.047.04 2.147 2.085 7.151-7.15z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Check = withIcon(SvgCheck);

const SvgCheckCircle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm3.528 3.146a.5.5 0 0 1 .059.638l-.058.07-4.991 5a.5.5 0 0 1-.657.044l-.069-.064-1.486-1.65a.5.5 0 0 1 .678-.73l.066.06 1.132 1.259 4.62-4.626a.5.5 0 0 1 .706 0z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CheckCircle = withIcon(SvgCheckCircle);

const SvgCheckCircleFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm3.528 4.146a.5.5 0 0 0-.707 0L6.202 9.774 5.07 8.515l-.066-.062a.5.5 0 0 0-.678.73l1.486 1.651.069.064a.5.5 0 0 0 .657-.045l4.99-5 .059-.07a.5.5 0 0 0-.059-.637z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CheckCircleFill = withIcon(SvgCheckCircleFill);

const SvgChevronDown = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M3.146 5.396a.5.5 0 0 1 .66-.041l.048.041L8 9.543l4.146-4.147a.5.5 0 0 1 .66-.041l.048.041a.5.5 0 0 1 .041.66l-.041.048-4.5 4.5a.5.5 0 0 1-.66.041l-.048-.041-4.5-4.5a.5.5 0 0 1 0-.708z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ChevronDown = withIcon(SvgChevronDown);

const SvgChevronLeft = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M5.396 7.646a.5.5 0 0 0-.041.66l.041.048 4.5 4.5a.5.5 0 0 0 .75-.66l-.042-.048L6.458 8l4.146-4.146a.5.5 0 0 0 .041-.66l-.041-.048a.5.5 0 0 0-.66-.041l-.048.041-4.5 4.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ChevronLeft = withIcon(SvgChevronLeft);

const SvgChevronRight = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.604 7.646a.5.5 0 0 1 .041.66l-.041.048-4.5 4.5a.5.5 0 0 1-.75-.66l.042-.048L9.543 8 5.396 3.854a.5.5 0 0 1-.041-.66l.041-.048a.5.5 0 0 1 .66-.041l.048.041 4.5 4.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ChevronRight = withIcon(SvgChevronRight);

const SvgChevronUp = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7.646 5.396a.5.5 0 0 1 .66-.041l.048.041 4.5 4.5a.5.5 0 0 1-.66.75l-.048-.042L8 6.458l-4.146 4.146a.5.5 0 0 1-.66.041l-.048-.041a.5.5 0 0 1-.041-.66l.041-.048 4.5-4.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ChevronUp = withIcon(SvgChevronUp);

const SvgClock = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm.5 2a.5.5 0 0 1 .492.41L9 4.5v4a.5.5 0 0 1-.41.492L8.5 9h-3a.5.5 0 0 1-.09-.992L5.5 8H8V4.5a.5.5 0 0 1 .41-.492L8.5 4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Clock = withIcon(SvgClock);

const SvgClose = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M3.05 3.05a.5.5 0 0 1 .707 0L8 7.293l4.243-4.243a.5.5 0 0 1 .707.707L8.707 8l4.243 4.243a.5.5 0 0 1-.707.707L8 8.707 3.757 12.95a.5.5 0 0 1-.707-.707L7.293 8 3.05 3.757a.5.5 0 0 1 0-.707z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Close = withIcon(SvgClose);

const SvgCloseCircleFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm2.854 4.146a.5.5 0 0 0-.66-.041l-.048.041L8 7.293 5.854 5.146l-.048-.041a.5.5 0 0 0-.66.749L7.293 8l-2.147 2.146-.057.07a.5.5 0 0 0 .717.68l.048-.042L8 8.707l2.146 2.147.048.041a.5.5 0 0 0 .66-.749L8.707 8l2.147-2.146.057-.07a.5.5 0 0 0-.057-.638z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CloseCircleFill = withIcon(SvgCloseCircleFill);

const SvgCloudDownload = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10 9a.5.5 0 0 1 .492.41l.008.09v3.793l.646-.647.07-.057a.5.5 0 0 1 .695.695l-.057.07-1.5 1.5-.07.057a.5.5 0 0 1-.568 0l-.07-.057-1.5-1.5-.057-.07a.5.5 0 0 1 0-.568l.057-.07.07-.057a.5.5 0 0 1 .568 0l.07.057.646.647V9.5A.5.5 0 0 1 10 9zM8.465 1c2.346 0 4.296 1.766 4.625 4.08l.016.138.083.044a3.603 3.603 0 0 1 1.805 2.935l.006.208c0 1.92-1.452 3.487-3.307 3.59L11.5 12v-1c1.386 0 2.5-1.153 2.5-2.595a2.597 2.597 0 0 0-1.563-2.4.5.5 0 0 1-.304-.435C12.032 3.57 10.42 2 8.465 2 6.585 2 5.01 3.46 4.813 5.368a.5.5 0 0 1-.462.448C3.034 5.908 2 7.036 2 8.405c0 1.378 1.044 2.502 2.36 2.59l.165.005H8.5v1H4.525C2.575 12 1 10.388 1 8.405c0-1.695 1.155-3.13 2.723-3.502l.153-.033.007-.037c.414-2.127 2.207-3.727 4.365-3.828L8.465 1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CloudDownload = withIcon(SvgCloudDownload);

const SvgCloudUpload = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.284 8.589l.07.057 1.5 1.5a.5.5 0 0 1-.638.765l-.07-.057-.646-.647V14l-.008.09a.5.5 0 0 1-.984 0L9.5 14v-3.793l-.646.647a.5.5 0 0 1-.638.057l-.07-.057a.5.5 0 0 1-.057-.638l.057-.07 1.5-1.5a.5.5 0 0 1 .638-.057zM8.465 1.5c2.346 0 4.296 1.766 4.625 4.08l.016.138.083.044a3.603 3.603 0 0 1 1.805 2.935l.006.208c0 1.92-1.452 3.487-3.307 3.59l-.193.005v-1c1.386 0 2.5-1.153 2.5-2.595a2.597 2.597 0 0 0-1.563-2.4.5.5 0 0 1-.304-.435c-.101-2-1.713-3.57-3.668-3.57-1.88 0-3.455 1.46-3.652 3.368a.5.5 0 0 1-.462.448C3.034 6.408 2 7.536 2 8.905c0 1.378 1.044 2.502 2.36 2.59l.165.005H8.5v1H4.525C2.575 12.5 1 10.888 1 8.905c0-1.695 1.155-3.13 2.723-3.502l.153-.033.007-.037c.414-2.127 2.207-3.727 4.365-3.828l.217-.005z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CloudUpload = withIcon(SvgCloudUpload);

const SvgCreditCard = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 2.5a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-9.5a.75.75 0 0 1 .75-.75h12.5zM14 7.3H2v5.2h12V7.3zm0-3.8H2v2h12v-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var CreditCard = withIcon(SvgCreditCard);

const SvgEmail = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 2.5a.8.8 0 0 1 .14.013.497.497 0 0 1 .596.603c.01.043.014.088.014.134v9.5a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-9.5c0-.047.004-.093.013-.137a.5.5 0 0 1 .598-.6.796.796 0 0 1 .139-.013h12.5zM14 4.015L8.304 8.396a.5.5 0 0 1-.529.051l-.08-.05-5.697-4.382L2 12.5h12V4.015zm-.972-.515H2.97L8 7.369 13.028 3.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Email = withIcon(SvgEmail);

const SvgExclamationCircle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1.2a5.8 5.8 0 1 0 0 11.6A5.8 5.8 0 0 0 8 2.2zm0 8.698a.602.602 0 1 1 0 1.204.602.602 0 0 1 0-1.204zM8 3.9a.6.6 0 0 1 .592.503L8.6 4.5v5.14a.6.6 0 0 1-1.192.098L7.4 9.641V4.5a.6.6 0 0 1 .6-.6z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ExclamationCircle = withIcon(SvgExclamationCircle);

const SvgExclamationCircleFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 9.898a.602.602 0 1 0 0 1.204.602.602 0 0 0 0-1.204zM8 3.9a.6.6 0 0 0-.6.6v5.14l.008.098A.6.6 0 0 0 8.6 9.641V4.5l-.008-.097A.6.6 0 0 0 8 3.9z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ExclamationCircleFill = withIcon(SvgExclamationCircleFill);

const SvgExternalLink = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 2v1H3v10h10V8h1v5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5zm5.501 0a.5.5 0 0 1 .5.5v3a.5.5 0 1 1-1 0V3.71L8.907 7.805a.5.5 0 0 1-.708 0 .518.518 0 0 1 0-.707L12.296 3h-1.795a.5.5 0 1 1 0-1h3z"
    }, void 0)
  }), void 0);
};

var ExternalLink = withIcon(SvgExternalLink);

const SvgEye = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 3c2.577 0 4.91 1.667 7 5-2.09 3.333-4.423 5-7 5s-4.91-1.667-7-5c2.09-3.333 4.423-5 7-5zm0 1C5.969 4 4.054 5.268 2.247 7.92L2.193 8l.054.08c1.74 2.554 3.58 3.824 5.528 3.915L8 12c2.031 0 3.946-1.268 5.753-3.92l.053-.08-.053-.08c-1.74-2.553-3.58-3.823-5.528-3.914L8 4zm0 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Eye = withIcon(SvgEye);

const SvgEyeSlash = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M2.603 3.55l.077.046 1.276.927.004-.005.843.614a7.433 7.433 0 0 0-.004.003l1.877 1.366.003-.003.85.62a.998.998 0 0 0-.003.001l1.458 1.06.85.619.169.122 3.34 2.433.019.012.318.23a.5.5 0 0 1-.51.856l-.078-.047-1.157-.841C10.694 12.52 9.382 13 8 13c-2.577 0-4.91-1.667-7-5 .703-1.121 1.433-2.054 2.191-2.798l-1.099-.798a.5.5 0 0 1 .51-.855zM4.01 5.8c-.599.568-1.186 1.273-1.763 2.12L2.193 8l.054.08c1.74 2.554 3.58 3.824 5.528 3.915L8 12c1.06 0 2.089-.345 3.087-1.053l-1.87-1.36A2 2 0 0 1 6.115 7.33L4.011 5.8zM8 3c2.577 0 4.91 1.667 7 5a16.666 16.666 0 0 1-1.592 2.164l-.81-.591c.39-.437.775-.934 1.155-1.492L13.806 8l-.053-.08c-1.74-2.554-3.58-3.824-5.528-3.915L8 4a4.98 4.98 0 0 0-2.28.563l-.892-.65C5.841 3.306 6.898 3 8 3zM7 7.974V8a1 1 0 0 0 1.332.943L7 7.973zM8 6a2 2 0 0 1 1.971 1.66L7.72 6.02C7.81 6.006 7.905 6 8 6z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var EyeSlash = withIcon(SvgEyeSlash);

const SvgFacebook = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.231 3.325l1.269-.001V1.098C11.281 1.068 10.528 1 9.65 1 7.822 1 6.57 2.16 6.57 4.29v1.836H4.5v2.488h2.069V15h2.474V8.614h2.065l.308-2.488H9.043v-1.59c0-.72.193-1.211 1.188-1.211",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Facebook = withIcon(SvgFacebook);

const SvgFilter = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 12.5a.5.5 0 0 1 .09.992l-.09.008h-9a.5.5 0 0 1-.09-.992l.09-.008h9zm0-5a.5.5 0 0 1 .09.992l-.09.008H3.501a.5.5 0 0 1-.09-.992l.09-.008H14.5zm0-5a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992L1.5 2.5h13z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Filter = withIcon(SvgFilter);

const SvgFlag = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M2.5 1l.703.312c.742.33 1.5.481 2.281.457l.054-.002c.362-.015.767-.065 1.576-.197l1.527-.256c1.143-.19 1.788-.276 2.342-.294 1.118-.037 1.947.273 2.427.963l.09.128v7.455l-.722-.359c-.604-.3-1.195-.447-1.778-.447-.227 0-.234-.012-.82.093l-1.867.344a32.53 32.53 0 0 1-.68.114l-.315.048c-.687.098-1.284.15-1.818.15-.85 0-1.512-.034-2-.109V15h-1V1zm8.656 1.015l-.14.003c-.422.014-.934.076-1.755.207l-2.221.369c-.633.1-1.008.146-1.347.165l-.177.008a6.07 6.07 0 0 1-1.9-.241L3.5 2.489v5.899l.113.02c.38.061.964.098 1.73.102H5.5c.48 0 1.032-.048 1.676-.14.4-.057.813-.128 1.34-.226l1.23-.23.306-.052c.41-.067.71-.1.948-.1.495 0 .99.082 1.483.245l.017.006v-5.57l-.012-.014c-.263-.271-.695-.415-1.332-.414z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Flag = withIcon(SvgFlag);

const SvgFlash = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11 .998H7a.5.5 0 0 0-.434.252l-4 7-.037.078a.5.5 0 0 0 .47.67h4.75l-2.21 5.308c-.222.53.481.954.847.51l7-8.5.047-.067a.5.5 0 0 0-.433-.75H9.349l2.088-3.758A.5.5 0 0 0 11 .998zm-.851 1L8.063 5.755l-.035.078a.5.5 0 0 0 .472.665h3.44l-4.181 5.078L8.96 8.69l.027-.082a.5.5 0 0 0-.488-.61H3.86l3.43-6h2.859z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Flash = withIcon(SvgFlash);

const SvgFlashSlash = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M3.223 3.79l.077.047 10 7.5a.5.5 0 0 1-.523.848l-.077-.048-3.943-2.956-.998 2.396.852-1.034a.5.5 0 0 1 .63-.12l.074.052a.5.5 0 0 1 .12.629l-.052.074-2.997 3.64c-.346.42-.996.063-.875-.427l.027-.083L7.75 9H3a.5.5 0 0 1-.47-.67l.036-.078.848-1.484a.5.5 0 0 1 .906.414l-.038.082L3.861 8l3.321-.001L2.7 4.637a.5.5 0 0 1 .523-.847zM11 1a.5.5 0 0 1 .472.665l-.035.078L9.35 5.5H13a.5.5 0 0 1 .433.75l-.047.068-1.657 2.012a.5.5 0 0 1-.823-.561l.05-.075.984-1.194H8.5a.5.5 0 0 1-.472-.665l.035-.078L10.149 2H7.29L6.003 4.253a.5.5 0 0 1-.6.223L5.32 4.44a.5.5 0 0 1-.224-.6l.038-.083 1.43-2.504a.5.5 0 0 1 .347-.244L7 1h4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var FlashSlash = withIcon(SvgFlashSlash);

const SvgGear = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.135 1a1 1 0 0 1 .968.747l.022.112.208 1.464.285.142c.12.064.236.133.353.209l.174.118 1.375-.55a1 1 0 0 1 1.092.233l.079.092.067.102.96 1.662a1 1 0 0 1-.157 1.205l-.092.081-1.166.915.017.212.006.256-.002.128-.004.128-.017.211 1.166.916a1 1 0 0 1 .344 1.063l-.04.113-.055.11-.96 1.662a1 1 0 0 1-1.121.467l-.117-.04-1.375-.551-.263.175a5.143 5.143 0 0 1-.355.2l-.194.094-.208 1.465a.99.99 0 0 1-.601.773l-.129.047-.123.029-.137.01H7.217a1 1 0 0 1-.914-.607l-.047-.118-.03-.133-.209-1.465-.284-.142a5.147 5.147 0 0 1-.35-.208l-.178-.12-1.373.552a.989.989 0 0 1-.962-.128l-.103-.086-.096-.101-.078-.113-.959-1.662a.999.999 0 0 1 .061-1.084l.086-.11.101-.092 1.165-.915-.015-.212L3.026 8l.001-.128.005-.128.015-.213-1.164-.914a.989.989 0 0 1-.37-.896l.022-.133.04-.134.059-.123.96-1.662a1 1 0 0 1 .982-.488L3.7 3.2l.13.041 1.374.551.264-.174c.115-.071.234-.138.355-.2l.193-.096.21-1.463a1 1 0 0 1 .766-.834l.11-.019L7.217 1h1.918zm0 1H7.217l-.25 1.743a.5.5 0 0 1-.312.394 4.145 4.145 0 0 0-1.063.616.5.5 0 0 1-.413.098l-.085-.025-1.592-.642-.043-.015-.938 1.621-.021.041 1.385 1.088a.5.5 0 0 1 .186.466 4.188 4.188 0 0 0 0 1.23.5.5 0 0 1-.121.406l-.065.06-1.35 1.059-.035.03.935 1.622.024.039 1.635-.657a.5.5 0 0 1 .498.073c.322.257.68.465 1.063.616a.5.5 0 0 1 .292.308l.02.086.241 1.698.009.045 1.872.002.046-.002.249-1.743a.5.5 0 0 1 .312-.394 4.163 4.163 0 0 0 1.063-.615.5.5 0 0 1 .413-.099l.085.026 1.635.656.96-1.662-1.386-1.088a.5.5 0 0 1-.185-.466 4.188 4.188 0 0 0 0-1.23.5.5 0 0 1 .12-.406l.065-.06 1.386-1.088-.96-1.662-1.635.656a.5.5 0 0 1-.498-.073 4.145 4.145 0 0 0-1.063-.615.5.5 0 0 1-.292-.308l-.02-.086L9.135 2zm-.96 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zm0 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Gear = withIcon(SvgGear);

const SvgGift = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.599 1c1.084 0 1.963.879 1.963 1.963 0 .794-.219 1.512-.772 2.038L14 5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1.952c-.554-.525-.772-1.243-.772-2.037C3.18 1.88 4.059 1 5.143 1s2.207.666 2.595 1.963c.053.176.097.344.132.504.037-.16.08-.328.133-.504A2.695 2.695 0 0 1 10.6 1zM6 6H2v8h4V6zm8 0h-4v8h4V6zM9 6H7v8h2V6zm1.599-4c-.743 0-1.403.467-1.638 1.25-.213.712-.25 1.25-.233 1.472l.005.05c.11.03.249.05.408.06l.122.006c.48.01.989-.081 1.365-.252.653-.298.934-.805.934-1.623A.963.963 0 0 0 10.599 2zM5.143 2a.963.963 0 0 0-.963.963c0 .818.28 1.325.934 1.623.376.171.885.262 1.365.252.167-.004.319-.02.44-.045l.088-.021.002-.007c.023-.178.002-.684-.188-1.374l-.041-.14C6.546 2.466 5.885 2 5.143 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Gift = withIcon(SvgGift);

const SvgGlobe = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm5.197 10.001H10.69a9.625 9.625 0 0 1-1.515 2.883 6.004 6.004 0 0 0 4.02-2.883zm-8.034 0h-2.36a6.01 6.01 0 0 0 3.848 2.847A9.593 9.593 0 0 1 5.163 11zm4.47 0H6.22a8.646 8.646 0 0 0 1.706 2.82 8.619 8.619 0 0 0 1.576-2.484l.131-.336zM4.896 6H2.34A5.99 5.99 0 0 0 2 8c0 .702.12 1.375.342 2h2.554a9.745 9.745 0 0 1 0-4zm5.037 0H5.92a8.737 8.737 0 0 0 0 4h4.013a8.739 8.739 0 0 0 .077-3.64L9.933 6zm3.726 0h-2.701a9.745 9.745 0 0 1 0 4h2.7A5.99 5.99 0 0 0 14 8a5.99 5.99 0 0 0-.341-2zm-7.01-3.849l-.175.044A6.012 6.012 0 0 0 2.803 5h2.36A9.625 9.625 0 0 1 6.65 2.152zm1.279.026l-.085.093A8.642 8.642 0 0 0 6.22 5h3.413a8.637 8.637 0 0 0-1.458-2.537l-.247-.286zm1.248-.063l.104.14A9.624 9.624 0 0 1 10.691 5h2.506a6.008 6.008 0 0 0-4.021-2.885z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Globe = withIcon(SvgGlobe);

const SvgGrid = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.5 9a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm-8.7 1.2H2.2v3.6h3.6v-3.6zm8 0h-3.6v3.6h3.6v-3.6zM6.5 1a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zM5.8 2.2H2.2v3.6h3.6V2.2zm8 0h-3.6v3.6h3.6V2.2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Grid = withIcon(SvgGrid);

const SvgGridFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.5 9a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm-8-8a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5zm8 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5h5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var GridFill = withIcon(SvgGridFill);

const SvgHeart = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.75 2A4.25 4.25 0 0 1 15 6.25c0 2.833-2.333 5.417-7 7.75-4.667-2.333-7-4.917-7-7.75a4.25 4.25 0 0 1 7-3.24A4.235 4.235 0 0 1 10.75 2zm0 1c-.704 0-1.371.224-1.922.63l-.18.142-.647.55-.648-.55A3.25 3.25 0 0 0 2 6.25c0 2.236 1.858 4.417 5.74 6.49l.26.136.26-.135c3.768-2.013 5.629-4.127 5.735-6.294L14 6.25A3.25 3.25 0 0 0 10.75 3z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Heart = withIcon(SvgHeart);

const SvgHeartFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.612 2C13.035 2 15 3.937 15 6.329c0 2.482-2.116 4.904-6.353 7.333l-.358.203-.34.135-.672-.381C3.093 11.207 1 8.799 1 6.329 1 3.937 2.965 2 5.388 2c.878 0 1.724.256 2.443.733L8 2.852l.179-.125a4.395 4.395 0 0 1 1.733-.672l.268-.034.273-.018.16-.003z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var HeartFill = withIcon(SvgHeartFill);

const SvgHistory = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.738 1.75C12.196 1.75 15 4.548 15 8s-2.804 6.25-6.262 6.25a6.253 6.253 0 0 1-4.795-2.23.498.498 0 1 1 .764-.642 5.254 5.254 0 0 0 4.031 1.875A5.258 5.258 0 0 0 14.002 8a5.258 5.258 0 0 0-5.264-5.253A5.258 5.258 0 0 0 3.475 8l-.005.046.672-.669.069-.058a.498.498 0 0 1 .637.762L3.35 9.578l-.07.057a.5.5 0 0 1-.636-.057L1.146 8.082l-.058-.07a.498.498 0 0 1 .058-.635l.07-.058a.5.5 0 0 1 .636.058L2.476 8c0-3.452 2.804-6.25 6.262-6.25zm-.5 3.282l.09.008c.233.042.41.245.41.49v2.652l2.182.872.08.04a.498.498 0 0 1-.45.885l-2.497-.997-.077-.038a.498.498 0 0 1-.236-.424V5.53l.008-.09a.5.5 0 0 1 .49-.408z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var History = withIcon(SvgHistory);

const SvgHome = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.25 1.067l.073.051 6.5 5.5a.5.5 0 0 1-.572.816l-.074-.052L14 7.23v7.27a.5.5 0 0 1-.41.492L13.5 15h-4a.5.5 0 0 1-.492-.41L9 14.5V12a1 1 0 0 0-1.993-.117L7 12v2.5a.5.5 0 0 1-.41.492L6.5 15h-4a.5.5 0 0 1-.492-.41L2 14.5V7.23l-.177.152a.5.5 0 0 1-.64.004l-.065-.063a.5.5 0 0 1-.004-.64l.063-.065 6.5-5.5a.5.5 0 0 1 .572-.051zM8 2.154l-5.011 4.24L3 6.5V14h3v-2a2 2 0 0 1 1.85-1.995L8 10a2 2 0 0 1 1.995 1.85L10 12v2h3V6.5a.52.52 0 0 1 .011-.105L8 2.154z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Home = withIcon(SvgHome);

const SvgIdCard = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 2.5a.75.75 0 0 1 .75.75v9.5a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75v-9.5a.75.75 0 0 1 .75-.75h12.5zm-.25 1H2v9h12v-9zM5.25 5.25a1.313 1.313 0 0 1 .909 2.26A1.498 1.498 0 0 1 7.5 9v1.5H3V9a1.5 1.5 0 0 1 1.341-1.492A1.313 1.313 0 0 1 5.25 5.25zm7.322 2.25a.5.5 0 0 1 .09.992l-.09.008H10a.5.5 0 0 1-.09-.992L10 7.5h2.572zm0-2a.5.5 0 0 1 .09.992l-.09.008H8.5a.5.5 0 0 1-.09-.992L8.5 5.5h4.072z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var IdCard = withIcon(SvgIdCard);

const SvgImage = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM5.5 8.5c-1.417 0-2.56.75-3.462 2.313L2 10.88V14h12v-2.999c-.606.497-1.448.749-2.5.749-1.116 0-1.818-.386-3.016-1.462l-.617-.564C6.841 8.8 6.298 8.5 5.5 8.5zM14 2H2v7.144C2.955 8.057 4.127 7.5 5.5 7.5c1.116 0 1.818.386 3.016 1.462l.617.564c1.026.924 1.569 1.224 2.367 1.224 1.395 0 2.18-.487 2.481-1.498l.019-.07V2zm-3.25 1a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5zm0 1a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Image = withIcon(SvgImage);

const SvgInfoCircle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm-1 9.5a.5.5 0 0 1-.09-.992L7 10.5h.499v-3H7a.5.5 0 0 1-.492-.41L6.5 7a.5.5 0 0 1 .41-.492L7 6.5h1.5l-.001 4H9a.5.5 0 0 1 .09.992L9 11.5H7zm.879-7.121a.621.621 0 1 1 0 1.242.621.621 0 0 1 0-1.242z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var InfoCircle = withIcon(SvgInfoCircle);

const SvgInstagram = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11 1a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5a4 4 0 0 1 4-4zM8 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zm0 1c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zm4-2a1 1 0 1 0 0 2 1 1 0 0 0 0-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Instagram = withIcon(SvgInstagram);

const SvgKeyboard = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 2.75a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75H1.75A.75.75 0 0 1 1 12.5v-9a.75.75 0 0 1 .75-.75h12.5zm-.25 1H2v8.5h12v-8.5zm-2.072 6l.09.008a.5.5 0 0 1 0 .984l-.09.008h-8l-.09-.008a.5.5 0 0 1 0-.984l.09-.008h8zM10 7.25v1H9v-1h1zm-3 0v1H6v-1h1zm-3 0v1H3v-1h1zm9 0v1h-1v-1h1zm-3-2v1H9v-1h1zm-3 0v1H6v-1h1zm-3 0v1H3v-1h1zm9 0v1h-1v-1h1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Keyboard = withIcon(SvgKeyboard);

const SvgLocation = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1c2.761 0 5 2.03 5 5.01 0 2.337-1.667 5.333-5 8.99-3.333-3.658-5-6.655-5-8.99C3 3.028 5.239 1 8 1zm0 1C5.708 2 4 3.66 4 6.01c0 1.828 1.272 4.291 3.861 7.323l.139.16.139-.16c2.497-2.922 3.768-5.317 3.856-7.124L12 6.01C12 3.662 10.291 2 8 2zm0 2.971a1.25 1.25 0 1 1 0 2.5 1.25 1.25 0 0 1 0-2.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Location = withIcon(SvgLocation);

const SvgLock = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a3.5 3.5 0 0 1 3.495 3.308l.005.192v2h1.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75H4.5v-2A3.5 3.5 0 0 1 8 1zm4.5 6.5h-9V14h9V7.5zM8 9.5a.5.5 0 0 1 .492.41L8.5 10v1.5a.5.5 0 0 1-.992.09L7.5 11.5V10a.5.5 0 0 1 .5-.5zM8 2a2.5 2.5 0 0 0-2.495 2.336L5.5 4.5v2h5v-2A2.5 2.5 0 0 0 8 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Lock = withIcon(SvgLock);

const SvgLockOpen = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a3.5 3.5 0 0 1 3.454 2.929.5.5 0 1 1-.987.162 2.5 2.5 0 0 0-4.962.245L5.5 4.5v2h7.25a.75.75 0 0 1 .75.75v7a.75.75 0 0 1-.75.75h-9.5a.75.75 0 0 1-.75-.75v-7a.75.75 0 0 1 .75-.75H4.5v-2A3.5 3.5 0 0 1 8 1zm4.5 6.5h-9V14h9V7.5zM8 9.5a.5.5 0 0 1 .492.41L8.5 10v1.5a.5.5 0 0 1-.992.09L7.5 11.5V10a.5.5 0 0 1 .5-.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var LockOpen = withIcon(SvgLockOpen);

const SvgMenu = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 12.5a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992l.09-.008h13zm0-5a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992L1.5 7.5h13zm0-5a.5.5 0 0 1 .09.992l-.09.008h-13a.5.5 0 0 1-.09-.992L1.5 2.5h13z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Menu = withIcon(SvgMenu);

const SvgMicrophone = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12 8a.5.5 0 0 1 .5.5c0 2.073-1.76 3.755-4 3.975V13.9l1.5.001a.55.55 0 0 1 .09 1.093L10 15H8.01A.51.51 0 0 1 8 15l-.01-.001L6 15a.55.55 0 0 1-.09-1.093L6 13.9l1.5-.001v-1.423c-2.24-.22-4-1.903-4-3.976a.5.5 0 0 1 1 0c0 1.64 1.553 3 3.5 3s3.5-1.36 3.5-3A.5.5 0 0 1 12 8zM8 1a2.5 2.5 0 0 1 2.5 2.5V8a2.5 2.5 0 0 1-5 0V3.5A2.5 2.5 0 0 1 8 1zm0 1a1.5 1.5 0 0 0-1.5 1.5V8a1.5 1.5 0 0 0 3 0V3.5A1.5 1.5 0 0 0 8 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Microphone = withIcon(SvgMicrophone);

const SvgMicrophoneSlash = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M3.191 3.53l9.509 7.133.077.047a.496.496 0 0 0 .097.037l.426.317c.22.165.265.477.1.697a.501.501 0 0 1-.624.147l-.076-.047-1.19-.89c-.729.8-1.8 1.345-3.01 1.464v1.468H10a.549.549 0 0 1 .09 1.09L10 15H6a.549.549 0 0 1-.09-1.089l.09-.007 1.5-.001v-1.468c-2.24-.22-4-1.896-4-3.962a.5.5 0 0 1 1 0c0 1.635 1.553 2.99 3.5 2.99 1.095 0 2.065-.429 2.704-1.094l-.898-.671A2.497 2.497 0 0 1 8 10.466 2.496 2.496 0 0 1 5.505 8.14L5.5 7.975V6.48L2.7 4.388a.497.497 0 0 1-.1-.697.501.501 0 0 1 .591-.162zM6.5 7.227v.747a1.5 1.5 0 0 0 2.496 1.118L6.5 7.228zm5.5.747a.5.5 0 0 1 .5.498c0 .25-.026.495-.075.732l-.925-.693v-.039a.5.5 0 0 1 .5-.498zM8 1a2.496 2.496 0 0 1 2.495 2.327l.005.164v4.271l-1-.75v-3.52c0-.826-.672-1.496-1.5-1.496-.78 0-1.42.593-1.493 1.351l-.007.144v1.271l-1-.75v-.52a2.495 2.495 0 0 1 2.336-2.487L8 1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var MicrophoneSlash = withIcon(SvgMicrophoneSlash);

const SvgMinus = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12.5 8a.5.5 0 0 1-.442.497L12 8.5H4a.5.5 0 0 1-.058-.997L4 7.5h8a.5.5 0 0 1 .5.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Minus = withIcon(SvgMinus);

const SvgMobile = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zm0 1H4v12h8V2zM8 12.5a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM10 3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h4zm0 1H6v7h4V4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Mobile = withIcon(SvgMobile);

const SvgMoney = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a.5.5 0 0 1 .5.5l.002 1.03c.565.069 1.003.246 1.399.407.564.228.86.469 1.124.682.22.18.262.511.085.735a.501.501 0 0 1-.714.085l-.213-.168a2.75 2.75 0 0 0-.661-.37c-.329-.132-.644-.26-1.02-.322L8.5 7.4l.24.071c.085.026.176.056.277.09l.16.056c.333.12.698.266 1.118.514.539.319.764.575.853.684l.02.026a2.79 2.79 0 0 1 .572 1.539l.01.346a2.45 2.45 0 0 1-.148.85 2.58 2.58 0 0 1-.498.813c-.315.347-.647.515-.867.628-.458.232-.846.309-1.158.373a5.85 5.85 0 0 1-.58.085L8.5 14.5a.5.5 0 0 1-.41.492L8 15a.5.5 0 0 1-.5-.5v-1.024a5.563 5.563 0 0 1-3.068-1.299.524.524 0 0 1-.061-.732.508.508 0 0 1 .722-.061c.299.255.632.47.987.641.286.136.606.246.925.321l.221.045c.083.015.175.029.273.04L7.5 8.205l-.434-.13-.35-.112c-.525-.173-.776-.29-.998-.421-.513-.299-.865-.637-1.047-1.002a2.244 2.244 0 0 1-.223-.897 2.734 2.734 0 0 1 .175-1.17c.207-.534.523-.858.743-1.056.388-.35.76-.494 1.059-.61a4.493 4.493 0 0 1 1.075-.27V1.5A.5.5 0 0 1 8 1zm.5 7.483l-.001 3.948c.117-.013.245-.033.38-.06.278-.056.565-.113.899-.284.189-.095.384-.193.57-.4.128-.14.232-.31.295-.478.074-.2.084-.377.082-.538l-.003-.117a1.849 1.849 0 0 0-.087-.555 1.718 1.718 0 0 0-.265-.508c-.111-.141-.31-.297-.593-.464a4.742 4.742 0 0 0-.702-.34l-.36-.132-.215-.072zM6.793 3.775c-.255.1-.496.194-.746.418l-.095.09c-.113.112-.27.297-.375.57l-.047.14a1.72 1.72 0 0 0-.06.577c.01.133.022.315.116.501.075.153.254.323.51.489l.134.082c.144.084.32.174.825.34l.445.14.002-3.537a3.528 3.528 0 0 0-.71.19z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Money = withIcon(SvgMoney);

const SvgMoneyCircle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm.132 2.625c.118 0 .213.087.242.196l.009.068v.485c.365.051.71.16 1.015.346l.178.122c.104.042.122.178.125.266v.046c0 .066 0 .205-.125.33-.063.061-.188.142-.283.142-.142 0-.204-.065-.237-.11a1.219 1.219 0 0 0-.518-.263l-.155-.033v1.389l.257.083.154.057c.589.232 1.127.616 1.127 1.455.028.33-.075.659-.297.916l-.063.069c-.17.192-.485.4-.983.487l-.195.026v.407a.267.267 0 0 1-.183.256l-.068.01H7.88a.258.258 0 0 1-.243-.197l-.009-.07v-.436c-.531-.077-1.034-.25-1.41-.58l-.072-.085a.338.338 0 0 1-.071-.21c0-.14.094-.233.142-.283a.466.466 0 0 1 .283-.123c.111 0 .195.05.232.078l.018.016c.158.13.39.28.69.372l.188.048V8.282L7.364 8.2c-.655-.214-1.241-.534-1.241-1.39 0-.73.551-1.271 1.344-1.426l.161-.026v-.47c0-.116.078-.222.185-.254l.067-.01h.252zM8.385 8.5v1.403a.908.908 0 0 0 .173-.044l.079-.03c.013-.008.03-.008.044-.014.26-.128.406-.335.408-.615a.561.561 0 0 0-.175-.418 1.12 1.12 0 0 0-.348-.21L8.385 8.5zm-.757-2.313c-.39.079-.658.312-.658.625 0 .264.199.416.529.546l.13.048V6.187z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var MoneyCircle = withIcon(SvgMoneyCircle);

const SvgMore = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM3.5 7a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm9 0a1 1 0 1 1 0 2 1 1 0 0 1 0-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var More = withIcon(SvgMore);

const SvgNote = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.5 1v1H2l-.001 8.5H5a.5.5 0 0 1 .492.41L5.5 11v2.998H14V5.502h1V14.5a.5.5 0 0 1-.41.492L14.5 15H4a.5.5 0 0 1-.293-.095l-.06-.051-2.5-2.499a.5.5 0 0 1-.14-.275L1 12.001V1.5a.5.5 0 0 1 .41-.492L1.5 1h9zm-6 10.5H1.999v.294l2.208 2.205.293-.001V11.5zm8.434-10.402l1.97 1.969a.33.33 0 0 1 0 .467l-6.37 6.37A.33.33 0 0 1 8.3 10H6V7.7a.33.33 0 0 1 .097-.234l6.37-6.37a.33.33 0 0 1 .467 0zM11.547 3.43L7 7.978V9h1.022l4.548-4.548-1.023-1.023zM5.009 7a.5.5 0 0 1 .09.993L5.009 8H3.518a.5.5 0 0 1-.09-.992L3.518 7h1.49zM6.5 5a.5.5 0 0 1 .09.993L6.5 6H3.518a.5.5 0 0 1-.09-.992L3.518 5H6.5zM8 3a.5.5 0 0 1 .09.993L8 4H3.518a.5.5 0 0 1-.09-.992L3.518 3H8zm4.7-.722l-.445.445 1.022 1.022.446-.445L12.7 2.278z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Note = withIcon(SvgNote);

const SvgPause = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M5.5 4.5a.5.5 0 0 1 .492.41L6 5v6a.5.5 0 0 1-.992.09L5 11V5a.5.5 0 0 1 .5-.5zm5 0a.5.5 0 0 1 .492.41L11 5v6a.5.5 0 0 1-.992.09L10 11V5a.5.5 0 0 1 .5-.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Pause = withIcon(SvgPause);

const SvgPencil = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11.516 1.64l2.844 2.844a.477.477 0 0 1 0 .675l-9.2 9.201a.477.477 0 0 1-.338.14H1.5v-3.322c0-.126.05-.248.14-.337l9.2-9.201a.477.477 0 0 1 .676 0zM9.593 4.3L2.5 11.393V13.5h2.105l7.094-7.094L9.593 4.3zm1.585-1.584l-.878.877 2.106 2.106.878-.877-2.106-2.106z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Pencil = withIcon(SvgPencil);

const SvgPhone = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M4.424 1.61l-1.313.526a2.563 2.563 0 0 0-1.58 2.77c.36 2.34 1.462 4.432 3.295 6.266C6.66 13.006 8.75 14.11 11.09 14.47a2.562 2.562 0 0 0 2.769-1.581l.532-1.332a1.532 1.532 0 0 0-.792-1.965l-2.232-1.007-.132-.052a1.53 1.53 0 0 0-1.794.635l-.521.83.192.097a6.747 6.747 0 0 1-1.9-1.326l-.227-.24a7.405 7.405 0 0 1-.993-1.411L5.92 6.98l.832-.558c.612-.41.845-1.198.555-1.876L6.4 2.43a1.53 1.53 0 0 0-1.976-.82zm1.057 1.213l.907 2.117c.1.235.02.509-.192.651l-1.013.68a.758.758 0 0 0-.257.965 8.423 8.423 0 0 0 1.579 2.24 7.745 7.745 0 0 0 2.178 1.522.757.757 0 0 0 .966-.282l.638-1.017a.531.531 0 0 1 .668-.202l2.232 1.007c.26.117.38.417.275.682l-.532 1.331a1.562 1.562 0 0 1-1.689.965c-2.123-.328-4.022-1.33-5.708-3.017-1.687-1.687-2.688-3.587-3.015-5.711-.11-.72.289-1.42.964-1.69l1.313-.526a.531.531 0 0 1 .686.285z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Phone = withIcon(SvgPhone);

const SvgPinterest = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M2.4 6.233c0 1.268.685 2.848 1.78 3.35.166.076.255.042.293-.116l.244-.98a.256.256 0 0 0-.061-.248c-.362-.434-.653-1.23-.653-1.973 0-1.908 1.465-3.753 3.96-3.753 2.155 0 3.663 1.447 3.663 3.518 0 2.34-1.198 3.96-2.757 3.96-.86 0-1.505-.702-1.298-1.563.247-1.028.726-2.138.726-2.88 0-.664-.361-1.218-1.109-1.218-.88 0-1.588.898-1.588 2.1 0 .767.264 1.285.264 1.285s-.87 3.623-1.029 4.298c-.176.747-.107 1.8-.03 2.483.04.593.325.664.598.207.358-.575.893-1.516 1.09-2.267l.547-2.056c.286.538 1.121.993 2.01.993 2.644 0 4.55-2.398 4.55-5.379C13.6 3.138 11.236 1 8.194 1 4.41 1 2.4 3.505 2.4 6.233z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Pinterest = withIcon(SvgPinterest);

const SvgPlay = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11.322 8.424l-6.557 4.098A.5.5 0 0 1 4 12.098V3.902a.5.5 0 0 1 .765-.424l6.557 4.098a.5.5 0 0 1 0 .848z"
    }, void 0)
  }), void 0);
};

var Play = withIcon(SvgPlay);

const SvgPlus = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 3.5a.5.5 0 0 1 .497.442L8.5 4v3.5H12a.5.5 0 0 1 .058.997L12 8.5H8.5V12a.5.5 0 0 1-.997.058L7.5 12V8.5H4a.5.5 0 0 1-.058-.997L4 7.5h3.5V4a.5.5 0 0 1 .5-.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Plus = withIcon(SvgPlus);

const SvgPrinter = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M11 1.5a.5.5 0 0 1 .5.5v2.5H14a1 1 0 0 1 .993.883L15 5.5V11a1 1 0 0 1-.883.993L14 12h-2v2a.5.5 0 0 1-.5.5h-7A.5.5 0 0 1 4 14v-2H2a1 1 0 0 1-.993-.883L1 11V5.5a1 1 0 0 1 .883-.993L2 4.5h2.5v-1l1.854-1.854a.5.5 0 0 1 .353-.146H11zm0 8.5H5v3.5h6V10zm-1.5 2a.5.5 0 0 1 .09.992L9.5 13h-3a.5.5 0 0 1-.09-.992L6.5 12h3zm0-1.5a.5.5 0 0 1 .09.992l-.09.008h-3a.5.5 0 0 1-.09-.992l.09-.008h3zm4.5-5H2V11h2V9.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5V11h2V5.5zm-10.5 1a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zm7-4H6.913L5.5 3.914V4.5h5v-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Printer = withIcon(SvgPrinter);

const SvgQrCode = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M5.5 1a.5.5 0 0 1 .5.5V3h1v1H6v1.5a.5.5 0 0 1-.5.5H7v1h2V6h1v2h1V7h3v1h-2v2h-1v2h-1v1H9v-2H7v-1H6V9H4v1h1.5a.5.5 0 0 1 .5.5V12h2v2H7v-1H6v1.5a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5H2V9h2V8h2V7H5V6H1.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5zM10 14v1H8v-1h2zm4 0v1h-1v-1h1zm-9-3H2v3h3v-3zm8 1v1h-1v1h-1v-2h2zm-9 0v1H3v-1h1zm10-2v1h-1v-1h1zm-4-2H8v2h2V8zm5 0v1h-1V8h1zM2 7v1H1V7h1zm12.5-6a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5V4H9v1H8V4h1V3h1V1.5a.5.5 0 0 1 .5-.5zM5 2H2v3h3V2zm9 0h-3v3h3V2zm-1 1v1h-1V3h1zM4 3v1H3V3h1zm4-2v1h1v1H7V1h1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var QrCode = withIcon(SvgQrCode);

const SvgQuestionCircle = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a7 7 0 1 1 0 14A7 7 0 0 1 8 1zm0 1a6 6 0 1 0 0 12A6 6 0 0 0 8 2zm-.2 8.898a.602.602 0 1 1 0 1.204.602.602 0 0 1 0-1.204zM7.8 4a2.436 2.436 0 0 1 .623 4.792l-.124.028.001.82a.5.5 0 0 1-.41.493l-.09.008a.5.5 0 0 1-.492-.41L7.3 9.64V8.373a.5.5 0 0 1 .5-.5 1.436 1.436 0 1 0-1.401-1.755.5.5 0 1 1-.976-.22A2.437 2.437 0 0 1 7.8 4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var QuestionCircle = withIcon(SvgQuestionCircle);

const SvgReceipt = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12.84 1a.5.5 0 0 1 .137.02A1.75 1.75 0 0 1 15 2.75v4.46h-2.471l.001 6.207a.5.5 0 0 1-.122.327l-.065.063-1.35 1.083a.5.5 0 0 1-.543.054l-.083-.054-1.037-.833-1.037.833a.5.5 0 0 1-.543.054l-.083-.054-1.037-.833-1.037.833a.5.5 0 0 1-.544.054l-.082-.054-1.036-.833-1.038.833a.5.5 0 0 1-.595.023l-.072-.06-1.08-1.083a.5.5 0 0 1-.14-.275L1 13.417V3a2 2 0 0 1 1.85-1.995L3 1h9.84zm-1.171 1H3a1 1 0 0 0-.993.883L2 3v10.209l.617.619 1.003-.802a.5.5 0 0 1 .543-.053l.083.054 1.034.831 1.037-.831a.5.5 0 0 1 .543-.054l.083.054 1.037.832 1.037-.832a.5.5 0 0 1 .543-.054l.083.054 1.037.832.849-.682V7.21H11.5V2.75c0-.269.06-.523.169-.75zm-1.773 8.22a.5.5 0 0 1 .09.992l-.09.008h-6.48a.5.5 0 0 1-.09-.992l.09-.008h6.48zm-1.62-3.24a.5.5 0 0 1 .09.992l-.09.008h-4.86a.5.5 0 0 1-.09-.992l.09-.008h4.86zM13.25 2a.75.75 0 0 0-.743.648l-.007.102.001 2.916a.496.496 0 0 1 .02.077l.009.09-.001.376H14V2.75a.75.75 0 0 0-.648-.743L13.25 2zM6.656 3.74a.5.5 0 0 1 .09.992l-.09.008h-3.24a.5.5 0 0 1-.09-.992l.09-.008h3.24z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Receipt = withIcon(SvgReceipt);

const SvgRefresh = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 7.5a.5.5 0 0 1 .5.5 7 7 0 0 1-7 7 6.963 6.963 0 0 1-4.501-1.648L3.5 14a.5.5 0 0 1-.41.492L3 14.5a.5.5 0 0 1-.492-.41L2.5 14v-2a.5.5 0 0 1 .41-.492L3 11.5h2a.5.5 0 0 1 .09.992L5 12.5l-.969-.001.033.03A6 6 0 0 0 14 8a.5.5 0 0 1 .5-.5zM8 1c1.674 0 3.255.591 4.5 1.638v-.76a.5.5 0 0 1 .41-.491l.09-.008a.5.5 0 0 1 .492.41l.008.09V4a.5.5 0 0 1-.41.492L13 4.5h-2a.5.5 0 0 1-.09-.992L11 3.5l.967-.002A6 6 0 0 0 2 8a.5.5 0 0 1-1 0 7 7 0 0 1 7-7z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Refresh = withIcon(SvgRefresh);

const SvgReturns = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M12.506 1.5a.5.5 0 0 1 .354.146l.062.077 1.827 2.749c.137.205.22.44.244.683l.007.147V8h-1V5.5H2v8h7v1H1.5a.5.5 0 0 1-.492-.41L1 14V5.303c0-.247.06-.49.176-.706l.076-.126 1.832-2.748a.5.5 0 0 1 .317-.213L3.5 1.5h9.006zm-.652 6.646a.5.5 0 0 1 .057.638l-.057.07-.148.146h.669a2.625 2.625 0 1 1-2.301 3.889.5.5 0 1 1 .876-.482 1.624 1.624 0 1 0 1.565-2.401l-.14-.006h-.668l.147.146a.5.5 0 0 1 .057.638l-.057.07a.5.5 0 0 1-.638.057l-.07-.057-1-1a.5.5 0 0 1-.057-.638l.057-.07 1-1a.5.5 0 0 1 .708 0zM6 11v1.5H3V11h3zm7.567-6.5l-1.329-2H8.5v2h5.067zM7.5 2.5H3.767l-1.334 2H7.5v-2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Returns = withIcon(SvgReturns);

const SvgRollback = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.695 6.86a1.082 1.082 0 0 0-.732-.28c-.274 0-.538.1-.732.28l-4.196 3.874V2.935a.924.924 0 0 0-.311-.662A1.082 1.082 0 0 0 7.999 2c-.27 0-.53.098-.724.273a.924.924 0 0 0-.311.662v7.8L2.768 6.86a1.082 1.082 0 0 0-.733-.28c-.275 0-.538.102-.732.282A.921.921 0 0 0 1 7.538c0 .254.11.497.304.677l5.964 5.507.016.013c.02.017.039.034.06.048l.04.028c.013.009.027.02.041.028l.046.026a.777.777 0 0 0 .09.043c.015.007.028.014.043.019l.047.016.049.016.047.01c.015.004.034.01.052.012l.052.008c.016.002.03.005.046.006.034.003.068.005.104.005.037 0 .068 0 .104-.005.016 0 .032-.004.047-.006s.036-.004.052-.008l.052-.011.046-.011.052-.016.045-.016.046-.02c.015-.006.031-.012.047-.02l.04-.023.047-.025c.015-.01.027-.02.042-.029l.04-.027.06-.048.015-.013 5.96-5.507a.955.955 0 0 0 .225-.311.893.893 0 0 0 0-.734.955.955 0 0 0-.226-.31z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Rollback = withIcon(SvgRollback);

const SvgSearch = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.5 1a5.5 5.5 0 0 1 4.227 9.02l4.127 4.126a.5.5 0 0 1-.638.765l-.07-.057-4.126-4.127A5.5 5.5 0 1 1 6.5 1zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Search = withIcon(SvgSearch);

const SvgShare = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6 5v1H4v8h8V6h-2V5h2a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h2zm2.355-3.854l2.121 2.122a.5.5 0 0 1-.707.707L8.503 2.709V9.5a.5.5 0 0 1-.5.5c-.245 0-.5-.22-.5-.5V2.706l-1.27 1.269a.5.5 0 1 1-.707-.707l2.122-2.122a.5.5 0 0 1 .707 0z"
    }, void 0)
  }), void 0);
};

var Share = withIcon(SvgShare);

const SvgSignIn = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 1l.09.008A.5.5 0 0 1 15 1.5v13l-.008.09a.5.5 0 0 1-.492.41H7l-.09-.008a.5.5 0 0 1-.41-.492l.008-.09A.5.5 0 0 1 7 14h7V2H7l-.09-.008A.5.5 0 0 1 7 1h7.5zM6.646 4.146a.5.5 0 0 1 .708 0l3.5 3.5.011.013a.503.503 0 0 1 .033.039l.013.018A.497.497 0 0 1 11 8v.02a.503.503 0 0 1-.005.052L11 8a.502.502 0 0 1-.146.354l.044-.052a.503.503 0 0 1-.033.04l-.011.012-3.5 3.5-.07.057a.5.5 0 0 1-.638-.057l-.057-.07a.5.5 0 0 1 .057-.638L9.293 8.5H1.5a.5.5 0 0 1-.09-.992L1.5 7.5h7.793L6.646 4.854l-.057-.07a.5.5 0 0 1 .057-.638z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var SignIn = withIcon(SvgSignIn);

const SvgSignOut = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9 1a.5.5 0 0 1 .09.992L9 2H2v12h7a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L9 15H1.5a.5.5 0 0 1-.492-.41L1 14.5v-13a.5.5 0 0 1 .41-.492L1.5 1H9zm1.646 3.146a.5.5 0 0 1 .708 0l3.5 3.5.011.013a.503.503 0 0 1 .033.039l.013.018A.497.497 0 0 1 15 8v.02a.503.503 0 0 1-.005.052L15 8a.502.502 0 0 1-.146.354l.044-.052a.503.503 0 0 1-.033.04l-.011.012-3.5 3.5-.07.057a.5.5 0 0 1-.638-.057l-.057-.07a.5.5 0 0 1 .057-.638L13.292 8.5H5.5a.5.5 0 0 1-.09-.992L5.5 7.5h7.794l-2.648-2.646-.057-.07a.5.5 0 0 1 .057-.638z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var SignOut = withIcon(SvgSignOut);

const SvgSpark = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7.996 1c-.531 0-.953.297-.953.656l.328 3.664c.031.22.305.39.625.39.328 0 .602-.17.64-.39l.321-3.664c0-.36-.422-.656-.96-.656zM2.988 4c-.312-.18-.781.04-1.047.5-.273.46-.226.977.094 1.156l3.328 1.555c.211.07.492-.078.657-.36.164-.28.148-.601-.024-.742L2.988 4zm10.985 1.656c.312-.18.359-.695.093-1.156-.273-.46-.742-.68-1.054-.5l-3.008 2.11c-.172.14-.188.46-.024.742.165.28.446.43.657.359l3.336-1.555zm-11.938 4.68c-.32.187-.367.703-.094 1.164.266.46.735.68 1.047.5l3.008-2.11c.172-.148.188-.468.024-.75-.165-.28-.446-.43-.657-.35l-3.328 1.546zm8.602-1.547c-.211-.078-.492.07-.657.352-.164.28-.148.601.024.75L13.012 12c.312.18.781-.04 1.054-.5.266-.46.22-.977-.093-1.164l-3.336-1.547zm-2.633 1.5c-.328 0-.602.164-.633.383l-.328 3.664c0 .367.422.664.953.664.54 0 .961-.297.961-.664l-.32-3.664c-.04-.219-.313-.383-.633-.383z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Spark = withIcon(SvgSpark);

const SvgStar = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.248 1.062a.566.566 0 0 1 .245.257l1.888 3.928 4.15.666a.575.575 0 0 1 .463.659.588.588 0 0 1-.158.323L11.852 9.99l.881 4.311a.579.579 0 0 1-.424.687.53.53 0 0 1-.359-.046L8 12.92l-3.95 2.02a.541.541 0 0 1-.74-.266.603.603 0 0 1-.043-.375l.881-4.311-2.984-3.094a.598.598 0 0 1-.004-.818.544.544 0 0 1 .309-.164l4.15-.666 1.888-3.928a.54.54 0 0 1 .741-.257zm1.458 5.09L7.999 2.6 6.294 6.151l-3.862.619 2.801 2.903-.808 3.951L8 11.796l3.574 1.828-.807-3.95 2.8-2.904-3.861-.619z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Star = withIcon(SvgStar);

const SvgStarFill = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 12.92l-3.95 2.02a.541.541 0 0 1-.74-.266.603.603 0 0 1-.043-.375l.881-4.311-2.984-3.094a.598.598 0 0 1-.004-.818.544.544 0 0 1 .309-.164l4.15-.666 1.888-3.928a.54.54 0 0 1 .986 0l1.888 3.928 4.15.666a.575.575 0 0 1 .463.659.588.588 0 0 1-.158.323L11.852 9.99l.881 4.311a.579.579 0 0 1-.424.687.53.53 0 0 1-.359-.046L8 12.92z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var StarFill = withIcon(SvgStarFill);

const SvgStarHalf = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.248 1.062a.566.566 0 0 1 .245.257l1.888 3.928 4.15.666a.575.575 0 0 1 .463.659.588.588 0 0 1-.158.323L11.852 9.99l.881 4.311a.579.579 0 0 1-.424.687.53.53 0 0 1-.359-.046L8 12.92l-3.95 2.02a.541.541 0 0 1-.74-.266.603.603 0 0 1-.043-.375l.881-4.311-2.984-3.094a.598.598 0 0 1-.004-.818.544.544 0 0 1 .309-.164l4.15-.666 1.888-3.928a.54.54 0 0 1 .741-.257zm1.458 5.09L7.999 2.6 8 11.796l3.574 1.828-.807-3.95 2.8-2.904-3.861-.619z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var StarHalf = withIcon(SvgStarHalf);

const SvgStore = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.3 1.225L12 4h2.5a.5.5 0 0 1 .5.5V15H9v-3.5H7V15H1V4.5a.5.5 0 0 1 .5-.5H4l3.7-2.775a.5.5 0 0 1 .6 0zM11.667 5L8 2.249 4.333 5H2v9h4v-3.5h4V14h4V5h-2.333z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Store = withIcon(SvgStore);

const SvgTag = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.5 1a.5.5 0 0 1 .492.41L15 1.5v6a.5.5 0 0 1-.095.294l-.051.06-7 7a.5.5 0 0 1-.638.057l-.07-.057-6-6a.5.5 0 0 1-.057-.638l.057-.07 7-7a.5.5 0 0 1 .275-.14L8.5 1h6zM14 2H8.706L2.207 8.5 7.5 13.793 14 7.292V2zm-2.573 2.586A2 2 0 1 1 8.6 7.414a2 2 0 0 1 2.828-2.828zm-2.121.707a1 1 0 1 0 1.414 1.414 1 1 0 0 0-1.414-1.414z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Tag = withIcon(SvgTag);

const SvgThumbDown = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.222 14.794c.408-.202.655-.66.768-1.214.05-.245-.019-.973-.213-2.317l-.193-1.277h3.917l.143-.007a1.499 1.499 0 0 0 .662-2.754 1.496 1.496 0 0 0-.5-1.997 1.496 1.496 0 0 0-.5-1.997 1.499 1.499 0 0 0-1.162-2.224L12 1l-4.55.003c-.676.068-1.1.174-1.62.384l-.53.227a5.706 5.706 0 0 1-1.019.328L4 1.998H1.5a.5.5 0 0 0-.492.41L1 2.498v6.489a.5.5 0 0 0 .41.491l.09.008H4c.621 0 1.771.64 2.423 1.494.174.227.406.835.64 1.645l.14.508.151.6c.08.33.139.599.151.686.105.726 1.12.672 1.717.375zM11 2.997a.5.5 0 0 0-.09.99l.09.008h1.5a.5.5 0 0 1 .09.99l-.09.008h-1a.5.5 0 0 0-.09.99l.09.009H13a.5.5 0 0 1 .09.99L13 6.99h-1a.5.5 0 0 0-.09.99l.09.009h1.5a.5.5 0 0 1 .09.99l-.09.008H9a.5.5 0 0 0-.494.577L8.7 10.82c.229 1.526.335 2.439.31 2.56-.058.282-.169.489-.232.52-.05.025-.175.056-.298.071l-.039.004-.008-.05c-.2-.989-.709-2.742-1.132-3.428l-.083-.123C6.436 9.35 5.12 8.583 4.173 8.496L4 8.488H2v-5.49l2.082-.007c.558-.093.97-.206 1.394-.37l.424-.177L6 2.4c.467-.203.788-.305 1.254-.37L7.5 2H12a.5.5 0 0 1 .09.99l-.09.008h-1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ThumbDown = withIcon(SvgThumbDown);

const SvgThumbUp = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.222 1.206c.408.202.655.66.768 1.214.05.245-.019.973-.213 2.317l-.193 1.277h3.917l.143.007a1.499 1.499 0 0 1 .662 2.754 1.496 1.496 0 0 1-.5 1.997 1.496 1.496 0 0 1-.5 1.997 1.498 1.498 0 0 1-1.162 2.224L12 15l-4.55-.003c-.676-.068-1.1-.174-1.62-.384l-.53-.227a5.706 5.706 0 0 0-1.019-.328L4 14.002H1.5a.5.5 0 0 1-.492-.41L1 13.502V7.013a.5.5 0 0 1 .41-.491l.09-.008H4c.621 0 1.771-.64 2.423-1.494.174-.227.406-.835.64-1.645l.14-.508.151-.6c.08-.33.139-.599.151-.686.105-.726 1.12-.672 1.717-.375zM11 13.003a.5.5 0 0 1-.09-.99l.09-.008h1.5a.5.5 0 0 0 .09-.99l-.09-.008h-1a.5.5 0 0 1-.09-.99l.09-.009H13a.5.5 0 0 0 .09-.99L13 9.01h-1a.5.5 0 0 1-.09-.99l.09-.01h1.5a.5.5 0 0 0 .09-.99l-.09-.008H9a.5.5 0 0 1-.494-.577L8.7 5.18c.229-1.526.335-2.439.31-2.56-.058-.282-.169-.489-.232-.52a1.156 1.156 0 0 0-.298-.071l-.039-.004-.008.05c-.2.989-.709 2.742-1.132 3.428l-.083.123C6.436 6.65 5.12 7.417 4.173 7.504L4 7.512H2v5.491l2.082.007c.558.093.97.206 1.394.37l.424.177.1.044c.467.203.788.305 1.254.37l.246.03H12a.5.5 0 0 0 .09-.99l-.09-.008h-1z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ThumbUp = withIcon(SvgThumbUp);

const SvgTrashCan = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M10.03 1a.5.5 0 0 1 .5.5V3h3a.5.5 0 0 1 .09.992L13.53 4h-1v10.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5V4h-1a.5.5 0 0 1-.09-.992L2.53 3h3V1.5a.5.5 0 0 1 .5-.5h4zm1.5 3h-7v10h7V4zm-2 1.5a.5.5 0 0 1 .492.41l.008.09v6a.5.5 0 0 1-.992.09L9.03 12V6a.5.5 0 0 1 .5-.5zm-3 0a.5.5 0 0 1 .492.41L7.03 6v6a.5.5 0 0 1-.992.09L6.03 12V6a.5.5 0 0 1 .5-.5zm3-3.5h-3v1h3V2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var TrashCan = withIcon(SvgTrashCan);

const SvgTruck = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.5 2.25a.5.5 0 0 1 .492.41l.008.09v1h2.5a.5.5 0 0 1 .312.11l.062.058 2 2.25a.5.5 0 0 1 .118.241L15 6.5v4.25a.5.5 0 0 1-.41.492l-.09.008H14a2 2 0 1 1-4 0H6.5a2 2 0 1 1-4 0h-1a.5.5 0 0 1-.492-.41L1 10.75v-8a.5.5 0 0 1 .41-.492l.09-.008h8zm-5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm7.5 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-3-7H2v7h.768a2 2 0 0 1 3.464 0H9v-7zm3.275 1.5H10v5.5h.268a2 2 0 0 1 3.464 0H14v-2.5h-1.752a.5.5 0 0 1-.09-.992l.09-.008H14v-.06l-1.725-1.94z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Truck = withIcon(SvgTruck);

const SvgTwitter = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M15 3.726a5.802 5.802 0 0 1-1.65.445 2.843 2.843 0 0 0 1.263-1.564 5.784 5.784 0 0 1-1.823.686 2.894 2.894 0 0 0-2.097-.893C9.107 2.4 7.82 3.667 7.82 5.228c0 .221.025.437.074.644a8.197 8.197 0 0 1-5.92-2.954 2.79 2.79 0 0 0-.389 1.421 2.81 2.81 0 0 0 1.278 2.353 2.882 2.882 0 0 1-1.3-.353c-.002.012-.002.024-.002.036 0 1.37.991 2.513 2.305 2.772a2.936 2.936 0 0 1-1.297.049 2.87 2.87 0 0 0 2.684 1.963 5.826 5.826 0 0 1-3.568 1.21A5.96 5.96 0 0 1 1 12.331 8.223 8.223 0 0 0 5.402 13.6c5.284 0 8.173-4.308 8.173-8.044 0-.123-.002-.245-.008-.365.56-.4 1.048-.898 1.433-1.465",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Twitter = withIcon(SvgTwitter);

const SvgUser = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8 1a3.5 3.5 0 0 1 2.425 6.023A3.998 3.998 0 0 1 14 11v4H2v-4a4 4 0 0 1 3.575-3.978A3.5 3.5 0 0 1 8 1zm2 7H6a3 3 0 0 0-2.995 2.824L3 11v3h10v-3a3 3 0 0 0-2.824-2.995L10 8zM8 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var User = withIcon(SvgUser);

const SvgUserPlus = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7.5 1a3.5 3.5 0 0 1 2.424 6.024 3.963 3.963 0 0 1 2.436 1.18.5.5 0 0 1-.715.699 2.983 2.983 0 0 0-1.932-.895L9.5 8h-4a3 3 0 0 0-2.995 2.824L2.5 11v3H8a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L8 15H2a.5.5 0 0 1-.492-.41L1.5 14.5V11a4 4 0 0 1 3.577-3.978A3.5 3.5 0 0 1 7.5 1zm4.5 9a.5.5 0 0 1 .492.41l.008.09-.001 1.5H14a.5.5 0 0 1 .09.992L14 13h-1.501l.001 1.5a.5.5 0 0 1-.992.09l-.008-.09-.001-1.5H10a.5.5 0 0 1-.09-.992L10 12h1.499l.001-1.5a.5.5 0 0 1 .5-.5zM7.5 2a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var UserPlus = withIcon(SvgUserPlus);

const SvgWallet = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14.25 4.248a.75.75 0 0 1 .75.75v8.25a.75.75 0 0 1-.75.75H1.75a.75.75 0 0 1-.75-.75V4.856a.75.75 0 0 1 .596-.734l10-2.103a.75.75 0 0 1 .904.733v1.496h1.75zM2 5.248v7.75h12v-2.25h-2.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 .75-.75H14v-2H2zm12 3h-2.5v1.5H14v-1.5zM11.5 3.06L5.854 4.247H11.5V3.06z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Wallet = withIcon(SvgWallet);

const SvgWalmartPay = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M5 2a.5.5 0 0 1 .09.992L5 3H2v10h3a.5.5 0 0 1 .492.41l.008.09a.5.5 0 0 1-.41.492L5 14H1.5a.5.5 0 0 1-.492-.41L1 13.5v-11a.5.5 0 0 1 .41-.492L1.5 2H5zm9.5 0l.09.008a.5.5 0 0 1 .402.402L15 2.5v11l-.008.09a.5.5 0 0 1-.402.402L14.5 14H11l-.09-.008a.5.5 0 0 1-.402-.402l-.008-.09.008-.09a.5.5 0 0 1 .402-.402L11 13h3V3h-3l-.09-.008a.5.5 0 0 1 0-.984L11 2h3.5zM8.002 9.304c.156 0 .294.069.344.167l.017.052.183 2.094c0 .21-.24.379-.549.379-.27 0-.49-.134-.536-.311l-.009-.068.188-2.094c.018-.125.174-.219.362-.219zm-1.134-.656c.078.134.085.283.028.378l-.042.05-1.719 1.206c-.178.102-.446-.023-.598-.286-.139-.234-.133-.493-.001-.623l.055-.042 1.902-.884c.12-.045.28.04.375.2zm2.584-.212l.054.01 1.906.885c.179.107.206.402.054.665-.14.234-.366.359-.54.312l-.063-.026-1.719-1.206c-.098-.084-.107-.267-.013-.428.08-.138.21-.22.321-.212zm-4.38-2.752l.063.026 1.72 1.206c.097.08.106.263.013.424-.079.134-.203.215-.312.215l-.063-.01-1.902-.888c-.183-.103-.21-.398-.054-.661.135-.234.362-.359.536-.312zm6.394.312c.135.234.129.493 0 .62l-.054.04-1.906.89c-.12.04-.281-.046-.375-.206-.08-.138-.085-.292-.023-.384l.036-.04 1.72-1.206c.178-.102.446.023.602.286zm-3.469-2c.274 0 .495.134.54.308l.01.067-.184 2.094c-.022.125-.178.223-.366.223-.157 0-.294-.072-.341-.172l-.016-.051-.188-2.094c0-.205.241-.375.545-.375z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var WalmartPay = withIcon(SvgWalmartPay);

const SvgWalmartPlus = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M9.797 10.95c.209 0 .391.108.403.253l.206 2.37c.02.234-.269.427-.608.427-.339 0-.623-.203-.608-.427l.206-2.37c.013-.141.194-.252.401-.252zm2.864-1.75l.059.014 2.108 1.007c.206.103.228.453.06.754-.17.3-.473.456-.664.324L12.32 9.928c-.109-.094-.117-.3-.014-.485.104-.185.282-.28.414-.23zM2.145 5.276c.107.55.411 2.148.411 2.148.127.656.245 1.345.334 1.89h.015c.086-.579.222-1.126.367-1.805l.512-2.233h1.133l.479 2.29c.126.638.225 1.129.304 1.721h.016c.086-.598.198-1.11.322-1.763l.46-2.248h1.087l-1.347 5.198c-.858.192-1.186-.16-1.305-.719-.117-.559-.347-1.623-.347-1.623-.118-.583-.21-.994-.275-1.592h-.017a16.898 16.898 0 0 1-.33 1.59l-.566 2.344c-.876.178-1.18-.085-1.349-.802A2544.65 2544.65 0 0 0 1 5.275h1.145zm7.64.678c.263 0 .472.185.478.375l.043 1.152 1.12.043c.184.007.365.22.365.49 0 .272-.18.486-.366.492l-1.122.043-.04 1.153c-.007.19-.215.374-.478.374-.264 0-.473-.185-.479-.375l-.042-1.152-1.12-.043c-.185-.007-.365-.22-.365-.49 0-.272.18-.486.365-.492l1.123-.046.04-1.15c.006-.189.214-.374.477-.374zm4.384-1.308c.192-.132.494.023.663.323.167.3.15.647-.06.751l-2.104 1.007c-.124.062-.31-.046-.414-.23-.103-.184-.104-.395.014-.482zM9.799 2c.338 0 .628.194.607.427l-.206 2.37c-.008.15-.194.252-.403.252-.206 0-.388-.113-.4-.252l-.206-2.37C9.169 2.187 9.46 2 9.798 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var WalmartPlus = withIcon(SvgWalmartPlus);

const SvgWalmartProtectionPlan = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M14 1a1 1 0 0 1 1 1v6.5C15 13 10 15 8 15s-7-2-7-6.5V2a1 1 0 0 1 1-1h12zm0 1H2v6.5C2 11.588 5.405 14 8 14c2.548 0 5.876-2.325 5.997-5.332L14 8.5V2zM5.475 9.897c.014 0 .026.007.038.017l.872.838h.002v-.79c0-.015.008-.029.02-.036l.023-.006h.267c.015 0 .028.008.036.021l.006.02v1.499c0 .018-.009.03-.021.036l-.021.004h-.023a.068.068 0 0 1-.038-.01l-.017-.014-.866-.87H5.75v.83a.043.043 0 0 1-.02.036l-.023.006h-.265a.044.044 0 0 1-.036-.022l-.006-.02v-1.5a.04.04 0 0 1 .021-.034l.021-.006h.034zm2.326 0a.8.8 0 0 1 .801.804.796.796 0 0 1-.801.799.794.794 0 0 1-.8-.8.8.8 0 0 1 .8-.803zm1.892 0a.04.04 0 0 1 .03.012l.008.013.345.783h.009l.191-.754a.047.047 0 0 1 .023-.027l.017-.004h.26c.024 0 .04.012.043.031l-.002.022-.421 1.496a.042.042 0 0 1-.023.027l-.017.004h-.036a.043.043 0 0 1-.028-.012l-.01-.012-.407-.91h-.007l-.405.91a.047.047 0 0 1-.022.02l-.016.004H9.19a.043.043 0 0 1-.032-.015l-.008-.016-.421-1.496c-.007-.023.002-.042.02-.05l.02-.003h.26c.012 0 .024.006.032.016l.009.015.191.754h.009l.345-.783a.045.045 0 0 1 .022-.021l.016-.004h.04zm-1.892.356a.446.446 0 0 0 0 .89.446.446 0 0 0 0-.89zM6.74 7.98a.8.8 0 0 1 .8.803c0 .445-.356.8-.8.8a.794.794 0 0 1-.8-.8c0-.445.354-.803.8-.803zm4.253 0c.223 0 .387.069.539.207a.042.042 0 0 1 .014.042l-.012.02-.174.18a.039.039 0 0 1-.055 0 .438.438 0 0 0-.3-.113c-.252 0-.437.209-.437.458a.44.44 0 0 0 .438.452.437.437 0 0 0 .299-.107.046.046 0 0 1 .04-.008l.017.01.174.185c.016.016.013.045-.002.06a.764.764 0 0 1-.541.216.802.802 0 1 1 0-1.603zm-7.161.022c.294 0 .499.223.499.492a.488.488 0 0 1-.426.496l-.07.005H3.6v.523a.044.044 0 0 1-.021.036l-.02.006h-.264a.042.042 0 0 1-.036-.021l-.006-.021V8.044c0-.015.008-.028.02-.036l.022-.006h.537zm1.431 0c.283 0 .486.216.486.48a.46.46 0 0 1-.264.419l-.066.03.305.565c.012.021.006.047-.014.058l-.024.006H5.39a.043.043 0 0 1-.028-.01l-.007-.01-.297-.59h-.153v.568a.044.044 0 0 1-.022.036l-.02.006h-.265a.042.042 0 0 1-.037-.021l-.006-.021V8.044c0-.015.008-.028.02-.036l.023-.006h.665zm3.453 0c.016 0 .03.009.037.021l.005.021v.243a.043.043 0 0 1-.02.036l-.022.006h-.319v1.189a.044.044 0 0 1-.021.036l-.02.006h-.268a.044.044 0 0 1-.036-.021l-.006-.021V8.329h-.319a.042.042 0 0 1-.036-.021l-.006-.021v-.243c0-.015.008-.028.02-.036l.022-.006h.989zm1.24 0a.04.04 0 0 1 .036.021l.006.021v.243a.043.043 0 0 1-.02.036l-.022.006H9.34v.276h.508c.014 0 .028.009.036.022l.006.02v.243c0 .016-.009.03-.022.037l-.02.005H9.34v.3h.617c.016 0 .03.01.036.022l.006.021v.243a.043.043 0 0 1-.02.036l-.022.006h-.922a.042.042 0 0 1-.037-.021l-.005-.021V8.044c0-.015.008-.028.02-.036l.022-.006h.922zm2.747 0a.04.04 0 0 1 .036.021l.006.021v.243a.043.043 0 0 1-.02.036l-.022.006h-.319v1.189a.044.044 0 0 1-.021.036l-.021.006h-.267a.044.044 0 0 1-.036-.021l-.007-.021V8.329h-.318a.042.042 0 0 1-.037-.021l-.005-.021v-.243c0-.015.008-.028.02-.036l.022-.006h.989zm-5.964.334a.446.446 0 0 0 0 .89.446.446 0 0 0 0-.89zm-2.914-.007H3.6v.34h.225c.096 0 .163-.075.163-.175 0-.08-.05-.144-.124-.16l-.039-.005zm1.41-.009h-.33v.347h.33c.09 0 .168-.073.168-.178 0-.09-.057-.15-.13-.165l-.039-.004zm6.052-3.114a.686.686 0 0 1 .301.288.662.662 0 0 1 .102.408c-.012.136-.065.229-.157.279l-1.976.918c-.062.024-.13.017-.204-.023a.489.489 0 0 1-.186-.19.408.408 0 0 1-.065-.247.264.264 0 0 1 .084-.19l1.782-1.252c.092-.049.198-.046.32.01zM5.03 5.197L6.813 6.45c.05.043.076.106.079.19a.468.468 0 0 1-.061.245.48.48 0 0 1-.185.191c-.074.04-.142.047-.204.023l-1.976-.918c-.092-.05-.145-.143-.157-.28a.662.662 0 0 1 .102-.407.686.686 0 0 1 .3-.288c.12-.055.227-.058.32-.009zM8 3.426c.155 0 .288.038.399.115.11.078.167.169.167.274l-.186 2.17c-.012.063-.055.117-.13.163a.455.455 0 0 1-.25.07.45.45 0 0 1-.255-.07c-.07-.046-.11-.1-.116-.162l-.195-2.171c0-.105.054-.196.162-.274A.68.68 0 0 1 8 3.426z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var WalmartProtectionPlan = withIcon(SvgWalmartProtectionPlan);

const SvgWarning = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsxs("g", Object.assign({
      fillRule: "evenodd"
    }, {
      children: [jsx("path", {
        d: "M8.557 1.132c.201.1.37.253.49.44l.067.117 5.754 11.508a1.246 1.246 0 0 1-.97 1.795l-.144.008H2.246a1.246 1.246 0 0 1-1.172-1.67l.058-.133L6.886 1.69a1.246 1.246 0 0 1 1.671-.557zm-.74.95l-.037.054-5.754 11.508a.246.246 0 0 0 .163.35l.057.006h11.508a.246.246 0 0 0 .241-.293l-.021-.063L8.22 2.136a.246.246 0 0 0-.066-.081l-.044-.029-.063-.021a.246.246 0 0 0-.23.077z"
      }, void 0), jsx("circle", {
        r: 0.5,
        cx: 8,
        cy: 12
      }, void 0), jsx("path", {
        d: "M8 5.5a.5.5 0 0 1 .492.41L8.5 6v4.14a.5.5 0 0 1-.992.09l-.008-.09V6a.5.5 0 0 1 .5-.5z"
      }, void 0)]
    }), void 0)
  }), void 0);
};

var Warning = withIcon(SvgWarning);

const SvgWiFi = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M7.994 11.5a.75.75 0 1 1-.002 1.499.75.75 0 0 1 .002-1.499zm2.613-1.418a.5.5 0 0 1-.705.708 2.687 2.687 0 0 0-3.806 0 .498.498 0 1 1-.705-.708 3.684 3.684 0 0 1 5.216 0zm2.46-1.979a.5.5 0 0 1-.706.707 6.16 6.16 0 0 0-8.724 0 .498.498 0 1 1-.706-.707 7.158 7.158 0 0 1 10.136 0zm1.787-2.259a.5.5 0 0 1-.706.707 8.683 8.683 0 0 0-12.296 0 .498.498 0 1 1-.706-.707 9.68 9.68 0 0 1 13.708 0z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var WiFi = withIcon(SvgWiFi);

const SvgWrench = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M8.248 2.292A3.864 3.864 0 0 0 7.4 5.87l.027.093-6.28 6.279a.5.5 0 0 0 0 .707l1.905 1.906.07.057a.5.5 0 0 0 .637-.057l6.283-6.282.095.028a3.867 3.867 0 0 0 4.628-5.065l-.038-.08a.5.5 0 0 0-.785-.102l-1.503 1.499-1.058-.232-.232-1.057 1.505-1.502a.5.5 0 0 0-.18-.823 3.867 3.867 0 0 0-4.074.894l-.152.16zM11.186 2l.108.005-1.045 1.045a.5.5 0 0 0-.135.462l.36 1.635a.5.5 0 0 0 .38.381l1.637.36.1.012a.5.5 0 0 0 .36-.146l1.043-1.042.006.106a2.867 2.867 0 0 1-3.91 2.716l-.08-.024a.5.5 0 0 0-.455.136l-6.15 6.147-1.198-1.199 6.147-6.143a.5.5 0 0 0 .112-.537A2.865 2.865 0 0 1 11.186 2z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var Wrench = withIcon(SvgWrench);

const SvgYouTube = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.554 9.936V5.742l3.783 2.104-3.782 2.09zm8.306-4.92s-.136-1.03-.556-1.483c-.533-.594-1.13-.597-1.403-.632-1.96-.151-4.898-.151-4.898-.151h-.006s-2.939 0-4.898.151c-.274.035-.87.038-1.403.632-.42.453-.556 1.482-.556 1.482S1 6.223 1 7.431v1.132c0 1.209.14 2.417.14 2.417s.137 1.03.556 1.482c.532.595 1.233.575 1.544.638 1.12.114 4.76.15 4.76.15s2.942-.004 4.9-.156c.275-.035.87-.037 1.403-.632.42-.453.557-1.482.557-1.482S15 9.772 15 8.563V7.431c0-1.208-.14-2.416-.14-2.416z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var YouTube = withIcon(SvgYouTube);

const SvgZoomIn = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.5 1a5.5 5.5 0 0 1 4.227 9.02l4.127 4.126a.5.5 0 0 1-.638.765l-.07-.057-4.126-4.127A5.5 5.5 0 1 1 6.5 1zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm0 2a.5.5 0 0 1 .492.41L7 4.5 6.999 6H8.5a.5.5 0 0 1 .09.992L8.5 7H6.999L7 8.5a.5.5 0 0 1-.992.09L6 8.5 5.999 7H4.5a.5.5 0 0 1-.09-.992L4.5 6h1.499L6 4.5a.5.5 0 0 1 .5-.5z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ZoomIn = withIcon(SvgZoomIn);

const SvgZoomOut = props => {
  return jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor"
  }, props, {
    children: jsx("path", {
      d: "M6.5 1a5.5 5.5 0 0 1 4.227 9.02l4.127 4.126a.5.5 0 0 1-.638.765l-.07-.057-4.126-4.127A5.5 5.5 0 1 1 6.5 1zm0 1a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9zm2 4a.5.5 0 0 1 .09.992L8.5 7h-4a.5.5 0 0 1-.09-.992L4.5 6h4z",
      fillRule: "evenodd"
    }, void 0)
  }), void 0);
};

var ZoomOut = withIcon(SvgZoomOut);

export { ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Article, Associate, Ban, Barcode, Bell, Box, Calendar, Camera, Car, CaretDown, CaretUp, Cart, CartFill, ChatBubble, Check, CheckCircle, CheckCircleFill, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Clock, Close, CloseCircleFill, CloudDownload, CloudUpload, CreditCard, Email, ExclamationCircle, ExclamationCircleFill, ExternalLink, Eye, EyeSlash, Facebook, Filter, Flag, Flash, FlashSlash, Gear, Gift, Globe, Grid, GridFill, Heart, HeartFill, History, Home, Icon, IdCard, Image, InfoCircle, Instagram, Keyboard, Location, Lock, LockOpen, Menu, Microphone, MicrophoneSlash, Minus, Mobile, Money, MoneyCircle, More, Note, Pause, Pencil, Phone, Pinterest, Play, Plus, Printer, QrCode, QuestionCircle, Receipt, Refresh, Returns, Rollback, Search, Share, SignIn, SignOut, Spark, Star, StarFill, StarHalf, Store, Tag, ThumbDown, ThumbUp, TrashCan, Truck, Twitter, User, UserPlus, Wallet, WalmartPay, WalmartPlus, WalmartProtectionPlan, Warning, WiFi, Wrench, YouTube, ZoomIn, ZoomOut, withIcon };
